export const pensionTransactions = {
  columnParams: 'grid-cols-[1fr,1fr,1fr] sm:grid-cols-[1fr,4fr,8rem]',
  columns: [
    [
      { id: 'date', type: 'date', textAlign: 'text-left' },
      // { id: 'description', type: 'string', textAlign: 'text-left', classNamesBody: 'truncate', classNamesBoth: 'sm:hidden' },
    ],
    [
      {
        id: 'description',
        type: 'string',
        textAlign: 'text-left',
        // classNamesBoth: 'hidden sm:block',
      },
    ],
    [
      {
        id: 'quantity',
        type: 'currency',
        usesHeader: 'amount',
        textAlign: 'text-right',
      },
    ],
  ],
};

export const pensionQuotes = {
  columnParams: 'grid-cols-[1fr,1fr,1fr,1fr] md:grid-cols-[8rem,1fr,1fr,1fr,1fr,1fr]',
  columns: [
    [
      {
        id: 'date',
        type: 'date',
        textAlign: 'text-left', // textAlign on item[0] determines alignment on the whole column and the HTML id of the entire cell
      },
    ],
    [
      { id: 'payoutOnlyContributionsToDate', type: 'currency', dashWhenNull: true },
      { id: 'payoutOnlyContributionsToDateIndexed', type: 'currency', classNamesBoth: 'md:hidden', dashWhenNull: true },
    ],
    [
      { id: 'payoutOnlyContributionsToDateIndexed', type: 'currency', classNamesBoth: 'hidden md:block', dashWhenNull: true },
      { id: 'payoutAllPlannedContributions', type: 'currency', classNamesBoth: 'md:hidden', dashWhenNull: true },
      { id: 'payoutAllPlannedContributionsIndexed', type: 'currency', classNamesBoth: 'md:hidden', dashWhenNull: true },
    ],
    [
      { id: 'payoutAllPlannedContributions', type: 'currency', classNamesBoth: 'hidden md:block', dashWhenNull: true },
      { id: 'payoutLumpSumVerrentet', type: 'currency', classNamesBoth: 'md:hidden', dashWhenNull: true },
    ],
    [{ id: 'payoutAllPlannedContributionsIndexed', type: 'currency', classNamesBoth: 'hidden md:block', dashWhenNull: true }],
    [{ id: 'payoutLumpSumVerrentet', type: 'currency', classNamesBoth: 'hidden md:block', dashWhenNull: true }],
  ],
};

const d = 1;
export default d;
